export default class ScrollyTellingVideoSlide {
  static outerVideoSlide = null;
  static videoSwiperComponent = null;

  static videoCount = 0;
  static activeIndex = 0;
  static activeVideo = null;
  static activeThumbnail = null;
  static activeThumbnailTimer = null;

  static soundEnabled = false;

  static activeVideoDuration = null;
  static activeVideoCurrentTime = null;

  static secondsInterval = null;

  static init(outerVideoSlide, videoSwiperComponent) {
    ScrollyTellingVideoSlide.outerVideoSlide = outerVideoSlide;
    ScrollyTellingVideoSlide.videoSwiperComponent = videoSwiperComponent;
    ScrollyTellingVideoSlide.videoCount =
      ScrollyTellingVideoSlide.outerVideoSlide.querySelectorAll(
        ".video-item"
      ).length;

    ScrollyTellingVideoSlide.videoSwiperComponent.slideTo(1);
    ScrollyTellingVideoSlide.videoSwiperComponent.slideTo(0);

    ScrollyTellingVideoSlide.outerVideoSlide
      .querySelector(".sound-toggle")
      .addEventListener("click", () => {
        ScrollyTellingVideoSlide.soundEnabled =
          !ScrollyTellingVideoSlide.soundEnabled;
        if (ScrollyTellingVideoSlide.soundEnabled) {
          ScrollyTellingVideoSlide.outerVideoSlide
            .querySelector(".sound-toggle")
            .classList.remove("muted");
          ScrollyTellingVideoSlide.activeVideo.muted = false;
        } else {
          ScrollyTellingVideoSlide.outerVideoSlide
            .querySelector(".sound-toggle")
            .classList.add("muted");
          ScrollyTellingVideoSlide.activeVideo.muted = true;
        }
      });
  }

  static beforeSlideChange(swiper) {
    // console.log('beforeSlideChange', swiper.activeIndex);
    let v =
      ScrollyTellingVideoSlide.videoSwiperComponent.slides[
        swiper.activeIndex
      ].querySelector("video");
    v.pause();
    v.currentTime = 0;
    v.muted = true;
  }

  static slideChange(swiper) {
    ScrollyTellingVideoSlide.activeIndex = swiper.activeIndex;
    ScrollyTellingVideoSlide.activeThumbnail =
      ScrollyTellingVideoSlide.outerVideoSlide.querySelectorAll(".video-item")[
        ScrollyTellingVideoSlide.activeIndex
      ];
    ScrollyTellingVideoSlide.activeThumbnailTimer =
      ScrollyTellingVideoSlide.activeThumbnail.querySelector(".vnav-progress");
    ScrollyTellingVideoSlide.outerVideoSlide
      .querySelectorAll(".video-item")
      .forEach((v) => v.classList.remove("active"));
    ScrollyTellingVideoSlide.activeThumbnail.classList.add("active");
    ScrollyTellingVideoSlide.activeVideo =
      ScrollyTellingVideoSlide.videoSwiperComponent.slides[
        ScrollyTellingVideoSlide.activeIndex
      ].querySelector("video");

    ScrollyTellingVideoSlide.videoSwiperComponent.wrapperEl
      .querySelectorAll("video")
      .forEach((v) => {
        //v.pause();
        //v.currentTime = 0;
        //v.muted = true;
      });

    //console.log(ScrollyTellingVideoSlide.outerVideoSlide);

    ScrollyTellingVideoSlide.activeVideo.play();
    if (ScrollyTellingVideoSlide.soundEnabled)
      ScrollyTellingVideoSlide.activeVideo.muted = false;

    clearInterval(ScrollyTellingVideoSlide.secondsInterval);
    ScrollyTellingVideoSlide.secondsInterval = setInterval(() => {
      ScrollyTellingVideoSlide.activeVideoCurrentTime =
        ScrollyTellingVideoSlide.activeVideo.currentTime;
      ScrollyTellingVideoSlide.activeVideoDuration =
        ScrollyTellingVideoSlide.activeVideo.duration;

      let secondsRemaining =
        ScrollyTellingVideoSlide.activeVideoDuration -
        ScrollyTellingVideoSlide.activeVideoCurrentTime;
      let percentage =
        (ScrollyTellingVideoSlide.activeVideoCurrentTime /
          ScrollyTellingVideoSlide.activeVideoDuration) *
        100;
      ScrollyTellingVideoSlide.activeThumbnailTimer.style.setProperty(
        "--value",
        `${percentage}%`
      );
      ScrollyTellingVideoSlide.activeThumbnailTimer.querySelector(
        ".vnav-progress-timer"
      ).innerText = formatTime(secondsRemaining);

      if (ScrollyTellingVideoSlide.secondsRemaining < 60)
        ScrollyTellingVideoSlide.activeThumbnailTimer.classList.add(
          "seconds-only"
        );
      else
        ScrollyTellingVideoSlide.activeThumbnailTimer.classList.remove(
          "seconds-only"
        );

      if (
        ScrollyTellingVideoSlide.activeVideoCurrentTime >=
        ScrollyTellingVideoSlide.activeVideoDuration
      )
        ScrollyTellingVideoSlide.videoSwiperComponent.slideNext();
    }, 100);
  }
}

function n0(n) {
  return n < 10 ? `0${n}` : n;
}

function formatTime(sec) {
  let minutes = Math.floor(sec / 60);
  let seconds = Math.floor(sec - minutes * 60);

  if (minutes) return `${n0(minutes)}:${n0(seconds)}`;
  else return `${n0(seconds)}`;
}
